module.exports = __webpack_public_path__ + "img/mail_montenach.433e64cc.webp";